import type { ComponentProps } from "react";
import { cn } from "@akina/utils";
import { isApp } from "../../utils/isApp";
import { getAssetFromCloudfront } from "../assets";
import { useTauriImage } from "../hooks";
import { Logo } from "./";

const CLOUDFRONT_IMAGE_NAMES = [
  "sideContentLayoutImage1",
  "sideContentLayoutImage2",
  "sideContentLayoutImage3",
  "sideContentLayoutImage4",
] as const;

const BUNDLED_ASSETS_SIDE_CONTENT_IMAGES = [
  "assets/side-content-layout-image-1.png",
  "assets/side-content-layout-image-2.png",
  "assets/side-content-layout-image-3.png",
  "assets/side-content-layout-image-4.png",
] as const;

const IMAGE_CARDS: (ComponentProps<typeof ImageCard> & { id: number })[] = [
  {
    id: 1,
    imagePath: getImageAt(0),
    bgColorHex: "#E3D9D5",
  },
  {
    id: 2,
    imagePath: getImageAt(1),
    bgColorHex: "#E4D8D1",
  },
  {
    id: 3,
    imagePath: getImageAt(2),
    bgColorHex: "#AEAF98",
  },
  {
    id: 4,
    imagePath: getImageAt(3),
    bgColorHex: "#FFF0E2",
  },
];

const ImageCard = ({
  imagePath,
  bgColorHex,
  className,
}: {
  imagePath: string;
  bgColorHex: string;
  className?: string;
}) => {
  const src = useTauriImage(imagePath);

  return (
    <div className={cn(`h-[405px] w-[316px] rounded-[32px]`, className)} style={{ backgroundColor: bgColorHex }}>
      {src ? (
        <img src={src} alt="" className="h-full w-full rounded-[32px] object-cover" />
      ) : (
        <div className="h-full w-full animate-pulse rounded-[32px] bg-gray-200" />
      )}
    </div>
  );
};

export const SideContentLayout = ({ children }: { children: React.ReactNode }) => {
  return (
    <div className="flex h-screen w-screen items-center justify-center overflow-hidden bg-offwhite">
      <div className="grid grid-cols-2 p-[72px]">
        <div className="flex h-full max-w-[800px] flex-col items-start justify-center gap-8 overflow-y-auto pr-4">
          <Logo className="mb-7 h-[57px] w-auto" />
          {children}
        </div>

        <div className="mt-[260px] flex gap-4">
          <div className="flex flex-col gap-4">
            {IMAGE_CARDS.slice(0, 2).map(({ id, ...card }) => (
              <ImageCard key={id} {...card} />
            ))}
          </div>
          <div className="mt-4 flex flex-col gap-4">
            {IMAGE_CARDS.slice(2, 4).map(({ id, ...card }) => (
              <ImageCard key={id} {...card} />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

function getImageAt(index: 0 | 1 | 2 | 3): string {
  return isApp ? BUNDLED_ASSETS_SIDE_CONTENT_IMAGES[index] : getAssetFromCloudfront(CLOUDFRONT_IMAGE_NAMES[index]);
}
